import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, ArrowLeft } from "lucide-react";
import { siteConfig, lockers } from "../mock";

const ChooseLocker = () => {
  const navigate = useNavigate();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 60);
    return () => clearTimeout(t);
  }, []);

  const goToLocker = (locker) => {
    if (!locker.href) {
      navigate("/dashboard");
      return;
    }
    window.location.href = locker.href;
  };

  return (
    <div className="stark-root">
      <div className="stark-glow stark-glow--tl" />
      <div className="stark-glow stark-glow--br" />
      <div className="stark-grain" />

      <main className="stark-center">
        <section
          className={`stark-card ${mounted ? "is-in" : ""}`}
          aria-label="Elige un acortador"
        >
          <h1 className="stark-title">{siteConfig.title}</h1>
          <p className="stark-tagline">Elige por dónde quieres conseguir tu key.</p>

          <div className="stark-actions">
            {lockers.map((locker, i) => (
              <button
                key={locker.id}
                type="button"
                onClick={() => goToLocker(locker)}
                className={`stark-btn stark-btn--${locker.variant}`}
                style={{ transitionDelay: `${140 + i * 70}ms` }}
              >
                <span className="stark-btn__icon">
                  <Sparkles size={16} strokeWidth={2.2} />
                </span>
                <span className="stark-btn__label">{locker.label}</span>
              </button>
            ))}

            <button
              type="button"
              onClick={() => navigate("/")}
              className="stark-btn stark-btn--secondary stark-back"
              style={{ transitionDelay: `${140 + lockers.length * 70}ms` }}
            >
              <span className="stark-btn__icon">
                <ArrowLeft size={16} strokeWidth={2.2} />
              </span>
              <span className="stark-btn__label">Volver</span>
            </button>
          </div>

          <p className="stark-footer">
            © {siteConfig.year} {siteConfig.title}
          </p>
        </section>
      </main>
    </div>
  );
};

export default ChooseLocker;
